import { addMessageParamToReturnUrls } from '../helpers/stripe_urls';
import { Provider, Providers, ReturnUrls } from './CheckoutTypes';

export function getPaymentProvider(
  providers: Providers,
  name: string,
): Provider | undefined {
  return providers.find((provider) => provider.name == name);
}

export function addMessageToReturnUrls(paymentReturnUrls: ReturnUrls) {
  const messageElement =
    (document.querySelector(
      'textarea[name="M_message"]',
    ) as HTMLInputElement) ||
    (document.querySelector('textarea[name="message"]') as HTMLInputElement);
  if (messageElement) {
    return addMessageParamToReturnUrls(paymentReturnUrls, messageElement.value);
  }
  return paymentReturnUrls;
}

const siteIdMap = new Map([
  ['1', 'spareroom_uk'],
  ['6', 'findaflat_uk'],
  ['7', 'speedflatmating_uk'],
  ['8', 'student_spareroom_uk'],
  ['12', 'spareroom_us'],
  ['21', 'appartager_fr'],
]);

export function getDomainString(id: string): string | undefined {
  return siteIdMap.get(String(id));
}
